import { Middleware, Context } from '@nuxt/types';

import featureFlags from '../lib/featureFlags';

const accountSetupGuard: Middleware = (context: Context) => {
  if (
    featureFlags.accountSetUpRequired &&
    context.store.getters['user/accountSetUpRequired']
  ) {
    context.app.router.push({ name: 'company-details' });
  }
};

export default accountSetupGuard;
